import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, callableErrorMessage } from "../lib/api";

export function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.requestPasswordReset({ email });
      setSent(true);
    } catch (err) {
      setError(callableErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-dvh bg-cream">
      <div className="container-page flex flex-col gap-6">
        <button onClick={() => nav("/login")} className="btn-ghost self-start px-3 py-2 text-sm">
          ← Volver al inicio de sesión
        </button>

        <header className="text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-leaf-600">Fideliza</p>
          <h1 className="mt-2 font-display text-2xl font-semibold text-leaf-950">
            ¿Olvidaste tu contraseña?
          </h1>
          <p className="mt-2 text-sm text-leaf-700">
            Te enviamos un link para restablecerla.
          </p>
        </header>

        {!sent ? (
          <form onSubmit={onSubmit} className="card flex flex-col gap-4">
            <input
              type="email"
              inputMode="email"
              autoComplete="email"
              required
              placeholder="tu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
            />
            {error && (
              <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                {error}
              </div>
            )}
            <button type="submit" disabled={busy} className="btn-primary">
              {busy ? "Enviando…" : "Enviar link"}
            </button>
          </form>
        ) : (
          <section className="card flex flex-col gap-3 text-center">
            <div className="grid h-12 w-12 place-items-self-center self-center place-items-center rounded-full bg-leaf-100">
              <svg viewBox="0 0 24 24" className="h-6 w-6 text-leaf-700" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 7l8 6 8-6" /><rect x="3" y="5" width="18" height="14" rx="2" />
              </svg>
            </div>
            <h2 className="font-display text-xl font-semibold text-leaf-950">Revisa tu inbox</h2>
            <p className="text-sm text-leaf-800">
              Si <strong>{email}</strong> tiene una cuenta, te llegará un link para restablecer la
              contraseña en los próximos minutos.
            </p>
            <p className="text-xs text-leaf-600">
              ¿No te llega? Revisa el spam o prueba con otro email.
            </p>
            <Link to="/login" className="btn-secondary mt-2">
              Volver al inicio de sesión
            </Link>
          </section>
        )}
      </div>
    </main>
  );
}
